/* Main product page: default to the most common in-stock variant, collapse sold-out values, sticky mobile add-to-cart. */
(function () {
  var dataEl = document.querySelector('script[id^="cv-purchase-data-"]');
  if (!dataEl) return;
  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var sid = cfg.sectionId;

  /* ---- 1. smart default is chosen server-side (Liquid); nothing to do on load ---- */

  /* ---- 2. collapse sold-out values (idempotent; re-runs after Dawn swaps the picker) ---- */
  function collapseSoldOut() {
    document.querySelectorAll('variant-selects fieldset.product-form__input--pill').forEach(function (fs) {
      var dis = fs.querySelectorAll('input[type="radio"].disabled');
      if (!dis.length || fs.querySelector('.cv-soldout-options')) return;
      if (fs.querySelector('.cvh7-pill--medium')) return; /* H7: every finish stays a visible pill */
      var det = document.createElement('details');
      det.className = 'cv-soldout-options';
      var sum = document.createElement('summary');
      sum.textContent = 'Unavailable options (' + dis.length + ')';
      det.appendChild(sum);
      dis.forEach(function (inp) {
        var label = inp.nextElementSibling;
        if (inp.checked) return; /* never hide the current selection */
        det.appendChild(inp);
        if (label && label.tagName === 'LABEL') det.appendChild(label);
      });
      if (det.children.length > 1) fs.appendChild(det);
    });
  }

  /* ---- 3. sticky mobile add-to-cart ---- */
  var bar, barPrice, barBtn, io;
  function mainButton() { return document.getElementById('ProductSubmitButton-' + sid); }
  function readPrice() {
    var box = document.getElementById('price-' + sid);
    if (!box) return '';
    var el = box.querySelector('.price-item--sale') || box.querySelector('.price-item--regular');
    return el ? el.textContent.trim() : '';
  }
  function syncBar() {
    var btn = mainButton();
    if (!bar || !btn) return;
    barPrice.textContent = readPrice();
    barBtn.disabled = btn.disabled;
    barBtn.querySelector('span').textContent = btn.disabled ? cfg.soldOutLabel : cfg.buttonLabel;
  }
  function observeButton() {
    var btn = mainButton();
    if (!btn || !bar) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = !e.isIntersecting && e.boundingClientRect.top < 0; /* only after the user scrolled past it */
      bar.classList.toggle('is-visible', below);
    });
    io.observe(btn);
  }
  function buildBar() {
    if (document.querySelector('.cv-sticky-atc') || !mainButton()) return;
    bar = document.createElement('div');
    bar.className = 'cv-sticky-atc';
    var info = document.createElement('div'); info.className = 'cv-sticky-atc__info';
    var t = document.createElement('span'); t.className = 'cv-sticky-atc__title'; t.textContent = cfg.title;
    barPrice = document.createElement('span'); barPrice.className = 'cv-sticky-atc__price';
    info.appendChild(t); info.appendChild(barPrice);
    barBtn = document.createElement('button');
    barBtn.type = 'button'; barBtn.className = 'button button--primary cv-sticky-atc__button';
    barBtn.appendChild(document.createElement('span'));
    barBtn.addEventListener('click', function () { var b = mainButton(); if (b && !b.disabled) b.click(); });
    bar.appendChild(info); bar.appendChild(barBtn);
    document.body.appendChild(bar);
    document.body.classList.add('cv-has-sticky-atc');
    syncBar(); observeButton();
  }

  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () { collapseSoldOut(); buildBar(); syncBar(); observeButton(); }, 60);
  }

  function init() {
    collapseSoldOut();
    buildBar();
    var root = document.querySelector('product-info') || document.body;
    var obs = new MutationObserver(refresh);
    var sels = root.querySelector('variant-selects');
    var price = document.getElementById('price-' + sid);
    var btn = mainButton();
    [sels, price, btn && btn.parentElement].forEach(function (el) { if (el) obs.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] }); });
    obs.observe(root, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
